export const BATCH_SIZE = 50;
export const UPLOAD_CONCURRENCY = 6;

export function batchFiles<T>(files: T[], batchSize: number): T[][] {
  const batches: T[][] = [];
  for (let i = 0; i < files.length; i += batchSize) {
    batches.push(files.slice(i, i + batchSize));
  }
  return batches;
}

export async function uploadWithConcurrency(
  tasks: (() => Promise<void>)[],
  concurrency: number,
): Promise<void> {
  const queue = [...tasks];

  const worker = async (): Promise<void> => {
    while (queue.length > 0) {
      const task = queue.shift();
      if (task) {
        try {
          await task();
        } catch {
          console.error('Error occurred while executing upload task.');
        }
      }
    }
  };

  await Promise.all(
    Array.from({ length: Math.min(concurrency, tasks.length) }, () => worker()),
  );
}
